import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectRouteTransition } from 'RouteAnimation';
import { useIsMobileViewport } from './useIsMobileViewport';

/*
    On mobile, show a spinner in place of the heavy sections until the route animation is idle. This keeps
    the slide-in smooth. When the deferral lifts, it does not come back.
*/
export function useDeferHeavyContentOnMobile() {
    const isMobile = useIsMobileViewport();
    const { phase } = useSelector(selectRouteTransition);

    // Seeded once, so a component mounted after the animation never defers.
    const [deferring, setDeferring] = useState(() => isMobile && phase !== 'idle');

    useEffect(() => {
        if (phase === 'idle') setDeferring(false);
    }, [phase]);

    return deferring;
}
